export const SITE_URL = 'https://www.bullverge.it'

export function normalizeSeoLocale(locale) {
  return String(locale || '').toLowerCase().slice(0, 2) === 'en' ? 'en' : 'it'
}

export function languageForLocale(locale) {
  return normalizeSeoLocale(locale) === 'en' ? 'en-US' : 'it-IT'
}

export function ogLocaleForLocale(locale) {
  return normalizeSeoLocale(locale) === 'en' ? 'en_US' : 'it_IT'
}

export function alternateOgLocaleForLocale(locale) {
  return normalizeSeoLocale(locale) === 'en' ? 'it_IT' : 'en_US'
}

export function localizedUrl(path = '/', locale = 'it') {
  const normalizedLocale = normalizeSeoLocale(locale)
  const url = new URL(path || '/', SITE_URL)

  if (normalizedLocale === 'en') {
    url.searchParams.set('lang', 'en')
  } else {
    url.searchParams.delete('lang')
  }

  return url.toString()
}

export function localizedAlternateLinks(path = '/') {
  return [
    { key: 'alternate-it', rel: 'alternate', hreflang: 'it', href: localizedUrl(path, 'it') },
    { key: 'alternate-en', rel: 'alternate', hreflang: 'en', href: localizedUrl(path, 'en') },
    { key: 'alternate-x-default', rel: 'alternate', hreflang: 'x-default', href: localizedUrl(path, 'it') }
  ]
}
